// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 750px) {\n.form-controls[data-v-5549bd8c] {\n        flex-direction: column;\n}\n}\n", ""]);
// Exports
module.exports = exports;
